import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { copyUrlButtonDriverFactory } from './CopyUrlButton.driver';
import { CopyUrlButton } from '.';

const testProps = {
  url: 'wix.com',
  tooltipText: 'Copy link',
  successText: 'Link Copied',
};

describe('CopyUrlButton', () => {
  const createDriver = createRendererWithUniDriver(copyUrlButtonDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(<CopyUrlButton {...testProps} />);
    expect(await driver.exists()).toBe(true);
  });
});
